import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-61206d08"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "banner-container"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "banner-buttons"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getAdInfo } from '@/api';
export default {
  __name: 'index',
  props: {
    adCode: Number,
    head: String,
    desc: String,
    imgSrc: String
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const isMin = ref(router.currentRoute.value.meta.minBanner);
    const styles = ref({});
    onMounted(async () => {
      try {
        if (props.imgSrc) {
          styles.value = {
            'background-image': `url("${props.imgSrc}")`
          };
        }
        if (props.adCode) {
          const res = await getAdInfo(props.adCode);
          styles.value = {
            'background-image': `url("${window.appConfig.apiUrl}/openApi/file/imagePreview/${res[0].img}")`
          };
        }
      } catch (e) {}
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['banner', isMin.value ? 'min-banner' : ''])
      }, [_createElementVNode("div", {
        class: "banner-img",
        style: _normalizeStyle(styles.value)
      }, null, 4), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "banner-title",
        innerHTML: props.head
      }, null, 8, _hoisted_2), _createElementVNode("div", {
        class: "banner-description",
        innerHTML: props.desc
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default")])])], 2);
    };
  }
};